import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { Bestellweg } from '@/types/bestellung';

type LookupResponse<T> = { type: string; items: T[] };

export function useBestellwege() {
  return useQuery({
    queryKey: ['lookups', 'bestellwege'],
    queryFn: () => apiFetch<LookupResponse<Bestellweg>>('/lookups.php?type=bestellwege'),
    staleTime: 10 * 60_000
  });
}
